import state from './state'
import * as getters from './getters'
import * as mutations from './mutations'
import axios from 'axios';

const actions = {
  async SignUp({commit}, form) {
    let config = {
      header : {
        'Content-Type' : 'multipart/form-data'
      }
    }
    let UserForm = new FormData()
    UserForm.append('company_id', 1)
    UserForm.append('first_name', form.first_name)
    //UserForm.append('middle_name', form.middle_name)
    UserForm.append('last_name', form.last_name)
    UserForm.append('username', form.username)
    UserForm.append('email', form.email)
    UserForm.append('password', form.password)
    UserForm.append('mobile_no', form.mobile_no)
    UserForm.append('avatar', form.avatar)
    UserForm.append('address', form.address)

    return new Promise((resolve, reject) => {
      axios.post('customer/register', UserForm, config).then((response) => {
        if(response.data.code == 200) {
          commit('setUser', response.data.data.user);
          commit('setLoginUserToken', response.data.data.token);
          axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.data.token}`;

          //Update Token Api
          localStorage.setItem("UserToken", response.data.data.token);
          let baseURL = localStorage.getItem("baseURL");
          let currentToken = localStorage.getItem('FCMToken');

          console.log('Sending token to server...');
          $.ajax({
            url: baseURL + 'customer/update_device_token',
            type: 'POST',
            contentType: "application/x-www-form-urlencoded; charset=urf-8",
            dataType: 'json',
            beforeSend: function (xhr) { xhr.setRequestHeader('Authorization', `Bearer ${response.data.data.token}`); },
            data: {
              device_id: Math.floor(999999999999 + Math.random() * 900066666699999999999),
              platform: 'web',
              device_token: currentToken,
              user_type : 'customer'
            },
            cache: false,
            success: function (result) {
              console.log('Token sent to server...');
              localStorage.setItem('FCMToken', currentToken);
            }, error: function () {
              console.log('Error');
            },
            timeout: 3000
          }).fail(function (jqXHR, textStatus) {
            if (textStatus === 'timeout') {
              console.log('Sorry!Please Wait... Slow connection!');
            }
          });
          resolve(response);
        } else {
          reject(response);
        }
      }).catch(error => {
        reject(error);
      });
    });
  },
  async LogIn({commit}, User) {
    return new Promise((resolve, reject) => {
      axios.post('customer/login', { username: User.username, password: User.password }).then((response) => {
        if(response.data.code == 200) {
          const user = response.data.data.user;
          commit('setUser', user);
          commit('setLoginUserToken', response.data.data.token);
          axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.data.token}`;
          localStorage.setItem('UserToken', `Bearer ${response.data.data.token}`);
          resolve(response);
        } else {
          commit('logOutUser')
          reject(response);
        }
      }).catch(error => {
        reject(error);
      });
    });
  },
  async LogOut({commit}) {
    let user = null
    axios.defaults.headers.common['Authorization'] = '';
    commit('logOutUser', user);
    localStorage.removeItem("UserToken");
  },
  updateUserInfo({commit}) {
    return new Promise((resolve, reject) => {
      axios.get('customer/user').then((response) => {
        if(response.data.code == 200) {
          const user = response.data.data;
          commit('setUser', user);
        }
      }).catch(error => {
      });
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js